import { Camera } from "lucide-react";
import { NoticeBox } from "@/components/NoticeBox";

/** Shown before the browser's camera permission prompt, so the prompt is not a surprise (QA-397). */
export const CAMERA_NOTICE_TEXT = "The camera is needed to read the code. Frames stay on your device and nothing is uploaded.";
export const CAMERA_PHOTO_NOTICE_TEXT = "The camera is needed to take the photo. Frames stay on your device and nothing is uploaded.";

export function CameraNotice({ purpose = "code" }: { purpose?: "code" | "photo" }) {
  return (
    <div className="px-4 max-w-md mx-auto text-left">
      <NoticeBox className="flex gap-2 items-start text-sm" testId="camera-notice">
        <Camera className="h-4 w-4 shrink-0 mt-0.5 text-primary" />
        <p>{purpose === "photo" ? CAMERA_PHOTO_NOTICE_TEXT : CAMERA_NOTICE_TEXT}</p>
      </NoticeBox>
    </div>
  );
}
